module.exports = __webpack_public_path__ + "static/media/daksh.bf9fe28c.jpg";